var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-single__notifications"},[_c('Icon',{staticClass:"card-single__notifications-icon",attrs:{"icon":"fas fa-bell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }